import { HistoryLogsEntry } from './history-logs/history-logs-entry.class';
export class HistoryLogs {
    logs;
    constructor(logs, useCase) {
        this.logs = logs.map((log) => new HistoryLogsEntry(log, useCase));
    }
}
